//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import { setRouter, setHistoryRouter, getHistoryRouter, setIframRouter } from '@/utils/storage'

export default {
  name: 'SidebarItem',
  data () {
    return {
      isRefresh: true,
      flag: false,
      isMenuPage: false //是否为菜单中配置的页面
    }
  },
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    $route (to) {
    }
  },
  computed: {
    ...mapGetters([
      'menuId'
    ])
  },
  methods: {
    selectMmenu (byProcessMessage) {
      var menus = this.$refs.menuItem
      menus.forEach(item => {
        if (item.active === true) {
          this.isMenuPage = true
          var routerData = item.$attrs.data
          this.handleSelectMenu(routerData, byProcessMessage)
        }
      })
      if (byProcessMessage && !this.isMenuPage) {
        let routerData = getHistoryRouter()
        this.handleSelectMenu(routerData, byProcessMessage)
      }
    },
    handleSelectMenu (data, byProcessMessage) {
      this.$store.dispatch('setMenuId', data) // 保存路由
      setRouter(JSON.stringify(data))
      setHistoryRouter(JSON.stringify(data))
      let time = String(new Date().getTime())
      if (data.href.indexOf('http://') === 0 || data.href.indexOf('https://') === 0 || data.href.indexOf('/') === 0) {
        if (!byProcessMessage) {
          // this.$router.push({ name: 'frame', href: '/frame', query: { resource: data.menuId, time: time } })
          let routeData = setIframRouter(data)
          routeData.query.time = time
          this.$router.push(routeData)
        }
      } else {
        this.routerIsValid(this.$router.options.routes, data.href) // 查询路由是否有效
        if (this.flag) {
          let routerInfo = this.getRouteInfo(data)
          if (routerInfo.name === 'htmlPage') {
            let params = {
              url: routerInfo.queryData.url
            }
            delete routerInfo.queryData.url
            this.$router.push({ name: routerInfo.name, params: params, query: { ...{ resource: data.menuId, time: time }, ...routerInfo.queryData } })
          } else {
            this.$router.push({ name: routerInfo.name, query: { ...{ resource: data.menuId, time: time }, ...routerInfo.queryData } })
          }
        } else {
          this.$router.push({ name: 'notfound', query: { resource: data.menuId, time: time } })
        }
      }
    },
    // 获取name和参数
    getRouteInfo (router) {
      let name = ''
      let queryData = {}
      if (router.href.indexOf('?') !== -1) {
        let arr = router.href.split('?')
        name = arr[0]
        let queryStr = arr[1]
        queryStr.split('&').forEach(item => {
          let params = item.split('=')
          if (params.length === 2) {
            queryData[params[0]] = params[1]
          }
        })
      } else {
        name = router.href
        queryData = {}
      }
      return {
        name: name,
        queryData: queryData
      }
    },
    // 判断路由是否有效
    routerIsValid (menuArr, url) {
      for (let item of menuArr) {
        if (this.flag) {
          return false
        }
        if (item.children && item.children.length) {
          this.routerIsValid(item.children, url)
        } else if (item.name === url.split('?')[0]) {
          this.flag = true
          return false
        }
      }
    }
    // hasOneShowingChildren (children) {
    //   const showingChildren = children.filter(item => {
    //     return !item.hidden
    //   })
    //   if (showingChildren.length === 1) {
    //     return true
    //   }
    //   return false
    // }
  }
}



// WEBPACK FOOTER //
// ./src/views/layout/components/Sidebar/SidebarItem.vue